import React from "react";
import { NavDropdown, Dropdown } from "react-bootstrap";
import { HideIfIntranet } from "app/header/parts/HideInPublicPages";
import { _t } from "app/i18n/i18n";
import { Link } from "app/header/parts/Link";
import { FaIcon } from "lib/FaIcon";
import { isIntranetPath } from "lib/routing";
import { isAdminUser, isReadershipUser, isPublishUser } from "lib/entitlements";
import { useHasPreference } from "pages/preferences/api/useGetPreferences";
import { READERSHIP_LINK } from "redux/slices/api/initialisePreferences";

export const DesktopPreferencesDropdown = ({ openMenu, setOpenMenu }) => {
  const readershipUrl = useHasPreference(READERSHIP_LINK, "New readership")
    ? "/research/grp-usage-analytics"
    : "/research/readership";

  return (
    <NavDropdown
      id="prefsDropdown"
      onMouseEnter={() => setOpenMenu("Preferences")}
      onMouseLeave={() => setOpenMenu(false)}
      onClick={() => setOpenMenu("Preferences")}
      show={openMenu === "Preferences"}
      title={<FaIcon icon="fa fa-cog ml-1" />}
      variant="dark"
      alignRight
      className="preferences-menu"
    >
      <Link to="/Preferences" icon="fa fa-cog " label={_t("Preferences")} />
      <Dropdown.Divider />
      <ExternalLink href="/research/japi/subscription_handshake" icon="far fa-bell" label={_t("My Subscriptions")} />
      <Link to="/My_Reading_List" label={_t("My Reading List")} icon="fab fa-stack-overflow" />

      {isIntranetPath() && (isReadershipUser() || isAdminUser() || isPublishUser()) ? <Dropdown.Divider /> : null}

      {isReadershipUser() && isIntranetPath() ? (
        <ExternalLink href={readershipUrl} icon="far fa-chart-bar" label={_t("Readership")} />
      ) : null}

      {isAdminUser() && isIntranetPath() ? (
        <ExternalLink href="/research/v1/admin/default.aspx" icon="fas fa-user-shield" label={_t("Admin")} />
      ) : null}

      {isPublishUser() && isIntranetPath() ? (
        <ExternalLink href="/research/v1/publish" icon="fas fa-upload" label={_t("Publish")} />
      ) : null}

      {/* Awaiting implementation:
    <Link to="/My_Reading_List" label="My Favourite Reports" icon= "fa fa-star" />
    <Link to="/My_Reading_List" label="My Reading History" icon= "fas fa-history" />
    <Link to="/My_Reading_List" label="My Search History" icon="fas fa-search" /> 
    */}

      <HideIfIntranet>
        <Dropdown.Divider />
        <Link to="/Sign_Out" icon="fa fa-sign-out-alt" label={_t("Sign Out")} />
      </HideIfIntranet>
    </NavDropdown>
  );
};

const ExternalLink = ({ className, href, icon, label }) => (
  <NavDropdown.Item href={href} className={className}>
    <FaIcon icon={icon} className="ml-0 mr-3 mr-md-3"></FaIcon>
    {label}
  </NavDropdown.Item>
);
